import { render } from "./patients-upcoming.vue?vue&type=template&id=1ececf9c"
import script from "./patients-upcoming.vue?vue&type=script&lang=js"
export * from "./patients-upcoming.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__